module.exports = __webpack_public_path__ + "static/media/plus-box.b770938d.svg";